import { render } from "./SurveyForm.vue?vue&type=template&id=fb91418a&scoped=true"
import script from "./SurveyForm.vue?vue&type=script&lang=js"
export * from "./SurveyForm.vue?vue&type=script&lang=js"

import "./SurveyForm.vue?vue&type=style&index=0&id=fb91418a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb91418a"]])

export default __exports__